import React, { useEffect, useRef, useState } from "react"
import * as styles from "./language-selector.module.scss"

import arrowBackIcon from "../../../../../../static/images/arrowBack.png"
import englishFlag from "../../../../../../static/images/flags/english_flag.png"
import frenchFlag from "../../../../../../static/images/flags/french_flag.png"
import germanFlag from "../../../../../../static/images/flags/german_flag.png"
import spanishFlag from "../../../../../../static/images/flags/spanish_flag.png"

import { KEY_CODES } from "../../dropdown-menu-bar/dropdown-menu-bar"
import * as config from "../../../../../../config"

const LanguageSelector: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const menuButtonRef = useRef(null)
  const menuContainerRef = useRef(null)

  const mainLocale = config.locales[0]
  const currentLocale = config.locale
  const otherLocales = config.locales.filter(locale => locale !== currentLocale)

  const focusMenu = () => menuButtonRef?.current?.focus()
  const focusFirstMenuItem = () => {
    if (typeof window === "undefined") {
      return
    }
    const firstMenuItem = document.getElementsByClassName(
      "jsMenuItem"
    )[0] as HTMLElement
    if (!firstMenuItem) {
      return
    }
    firstMenuItem.focus()
  }
  const openMenu = () => setIsOpen(true)
  const hasDropdown = otherLocales.length > 0

  function closeMenu() {
    setIsOpen(false)
  }

  // When the menu lose focus, we need to close it
  useEffect(() => {
    if (!isOpen || typeof window === "undefined") {
      return
    }
    const onFocus = event => {
      if (
        !event.target.classList ||
        !event.target.classList.contains("jsMenuFocusable")
      ) {
        closeMenu()
        window.removeEventListener("focus", onFocus, true)
      }
    }
    window.addEventListener("focus", onFocus, true)
    return () => window.removeEventListener("focus", onFocus, true)
  }, [isOpen])

  function closeMenuOnEscape<T>(event: React.KeyboardEvent<T>) {
    switch (event.keyCode) {
      case KEY_CODES.ESC:
        event.preventDefault()
        focusMenu()
        closeMenu()
        return
      default:
        return
    }
  }

  if (!hasDropdown) {
    return (
      <div className={styles.languageSelectorMenu}>
        <div id="languageSelectorMenu" className={styles.menuButton}>
          <img
            src={getLocaleFlag(currentLocale)}
            className={styles.countryFlag}
            alt=""
            aria-hidden="true"
            //width={48}
            //height={48}
          />
          <span className={styles.countryLabel}>{currentLocale}</span>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.languageSelectorMenu}>
      <button
        id="languageSelectorMenu"
        className={styles.menuButton + " jsMenuFocusable"}
        aria-haspopup={hasDropdown}
        aria-controls="flagItems"
        aria-expanded={isOpen && hasDropdown}
        onClick={() => {
          openMenu()
          focusFirstMenuItem()
        }}
        title={config["language_selector_title"][config.locale]}
        onKeyDown={closeMenuOnEscape}
        ref={menuButtonRef}
        disabled={!hasDropdown}
      >
        <img
          src={getLocaleFlag(currentLocale)}
          className={styles.countryFlag}
          alt=""
          aria-hidden="true"
          //width={48}
          //height={48}
        />
        <span className={styles.countryLabel}>{currentLocale}</span>
        {hasDropdown && (
          <img
            src={arrowBackIcon}
            className={styles.arrowIcon}
            alt=""
            aria-hidden="true"
          />
        )}
      </button>
      {hasDropdown && (
        <div
          className={
            isOpen
              ? `${styles.dropdownContent} ${styles.active}`
              : styles.dropdownContent
          }
        >
          <ul
            id="flagItems"
            aria-labelledby="languageSelectorMenu"
            ref={menuContainerRef}
            onKeyDown={closeMenuOnEscape}
          >
            {otherLocales.map(locale => {
              return (
                <li key={locale}>
                  <a
                    className={
                      styles.subMenuButton + " jsMenuFocusable jsMenuItem"
                    }
                    href={locale === mainLocale ? "/" : "/lang-" + locale}
                    onKeyDown={closeMenuOnEscape}
                  >
                    <img
                      src={getLocaleFlag(locale)}
                      className={styles.countryFlag}
                      alt=""
                      aria-hidden="true"
                      //width={48}
                      //height={48}
                    />
                    <span className={styles.countryLabel}>{locale}</span>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

function getLocaleFlag(locale: string) {
  switch (locale) {
    case "fr":
      return frenchFlag
    case "en":
      return englishFlag
    case "es":
      return spanishFlag
    case "de":
      return germanFlag
    default:
      return frenchFlag
  }
}

export default LanguageSelector
